<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEmailOutline } from "@mdi/js";
export default {
  name: "MdiAccount",
  data() {
    return {
      svgPath: mdiEmailOutline,
    };
  },
};
</script>
